export const REPEAT_OPTIONS = [
  { unit: "once", label: "One time" },
  { unit: "days", label: "Custom (days)" },
  { unit: "weeks", label: "Week(s)" },
  { unit: "months", label: "Month(s)" },
  { unit: "years", label: "Year(s)" },
];

// How each repeat option reads in the dropdown. "Custom (days)" already says what
// it is, so it skips the "Every…" prefix that "Week(s)"/"Month(s)"/"Year(s)" get
// (those need it since the exact interval is set separately, in the "Every" field).
export const repeatOptionLabel = ({ unit, label }) => (unit === "once" || unit === "days" ? label : `Every… ${label}`);

export const localToday = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const repeatLabel = ({ repeatUnit, repeatEvery }) => {
  if (repeatUnit === "once") return "One time";
  const names = { days: ["Every day", "days"], weeks: ["Every week", "weeks"], months: ["Every month", "months"], years: ["Every year", "years"] };
  const [single, plural] = names[repeatUnit];
  return repeatEvery === 1 ? single : `Every ${repeatEvery} ${plural}`;
};

export const formatDue = (task) => {
  const date = new Date(`${task.dueDate}T00:00:00`).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
  return task.dueTime ? `${date}, ${task.dueTime}` : date;
};

const dayDiff = (dateStr, today) => Math.round((new Date(`${dateStr}T00:00:00`) - new Date(`${today}T00:00:00`)) / 86400000);

export const dueText = (task, today = localToday()) => {
  if (task.state === "completed") return "Completed";
  const d = dayDiff(task.dueDate, today);
  if (d < 0) return `${Math.abs(d)} day${d === -1 ? "" : "s"} overdue`;
  if (d === 0) return "Due today";
  if (d === 1) return "Due tomorrow";
  return `Due in ${d} days`;
};

// Who has to do something with this task right now?
//  - "todo":    I need to do it (and it is due today or overdue)
//  - "confirm": someone submitted it and I am an admin who has to confirm
//  - "waiting": I submitted it and am waiting for an admin
//  - "later":   open, not due yet
//  - "others":  open, but somebody else is the doer
//  - "done":    completed one-time task
export const taskBucket = (task, today = localToday()) => {
  if (task.state === "completed") return "done";
  if (task.state === "submitted") return task.myRole === "admin" ? "confirm" : "waiting";

  const doers = task.members.filter((m) => m.role === "doer");
  const iAmTheDoer = task.myRole === "doer" || doers.length === 0;
  if (!iAmTheDoer) return "others";
  return task.dueDate <= today ? "todo" : "later";
};

export const actionCount = (tasks, today = localToday()) =>
  tasks.filter((t) => {
    const b = taskBucket(t, today);
    return b === "todo" || b === "confirm";
  }).length;

// What the main button on a task should do for me.
export const primaryAction = (task) => {
  if (task.state === "completed") return null;
  if (task.myRole === "admin") {
    if (task.state === "submitted") return { kind: "confirm", label: "Confirm it's done" };
    const doers = task.members.filter((m) => m.role === "doer");
    return doers.length === 0 ? { kind: "confirm", label: "Mark as done" } : null;
  }
  if (task.state === "open") return { kind: "submit", label: "I've done it" };
  return null;
};
